import MuiDrawer from '@mui/material/Drawer'
import { styled } from '@mui/material/styles'

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => !['open', 'width'].includes(prop),
})(({ width, theme, open }) => ({
  width,
  flexShrink: 0,
  boxSizing: 'border-box',
  ...(open && {
    width,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(!open && {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
  }),
  '.MuiDrawer-paper': {
    position: 'relative',
    backgroundColor: 'transparent',
    border: 0,
    overflowX: 'hidden',
  },
}))

export default Drawer
